import { fetchUserPreferencesWithApp } from 'utils/apiHelper';
import { parsePreferenceSettings } from 'utils/ipdReportTemplateUtils';

export const DEFAULT_AUTO_WHATSAPP_SETTINGS = Object.freeze({
  prescription: true,
  lab_invoice: true,
  pharmacy_invoice: true,
  lab_report: true,
  radiology_report: true
});

const PREFIX_TO_CATEGORY = Object.freeze({
  prescription: 'prescription',
  'lab-invoice': 'lab_invoice',
  'pharmacy-invoice': 'pharmacy_invoice',
  'lab-report': 'lab_report',
  'radiology-report': 'radiology_report'
});

let settingsPromise;

export const getAutoWhatsAppCategory = (actionKey) =>
  PREFIX_TO_CATEGORY[String(actionKey || '').split(':')[0]] || null;

export const normalizeAutoWhatsAppSettings = (settings) => ({
  ...DEFAULT_AUTO_WHATSAPP_SETTINGS,
  ...(settings && typeof settings === 'object' ? settings : {})
});

export const fetchAutoWhatsAppSettings = async () => {
  if (!settingsPromise) {
    settingsPromise = fetchUserPreferencesWithApp(true)
      .then((preferences) => {
        const settings = parsePreferenceSettings(preferences?.settings);
        return normalizeAutoWhatsAppSettings(settings.auto_send_whatsapp);
      })
      .catch((error) => {
        settingsPromise = undefined;
        throw error;
      });
  }
  return settingsPromise;
};

export const isAutoWhatsAppEnabled = async (actionKey) => {
  const category = getAutoWhatsAppCategory(actionKey);
  if (!category) return true;
  const settings = await fetchAutoWhatsAppSettings();
  return settings[category] !== false;
};

export const clearAutoWhatsAppSettingsCache = () => {
  settingsPromise = undefined;
};